import { render, staticRenderFns } from "./IconTrashSolid.vue?vue&type=template&id=52e66af7"
import script from "./IconTrashSolid.vue?vue&type=script&lang=js"
export * from "./IconTrashSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports